const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://k3ft90ylt5.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://11zsvse637.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.3',
    HOSTNAME: 'https://company.dev.dlpocclient.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.dev.dlpocclient.forwoodsafety.com',
    WEBSOCKET: 'wss://9ltq2u61yc.execute-api.us-west-2.amazonaws.com/dev'
  },
};

export default config;